import React, { useEffect, useState } from "react";
import { EmployeeAuthContext } from "./useEmployeeAuthContext";
import API_URL from "../api/API";

export const EmployeeAuthContextProvider = ({ children }) => {

    const [employee, setEmployee] = useState(null);


    // LOGIN
    const login = async (phone, pin) => {

        const response = await fetch(
            API_URL.FRONTEND_EMPLOYEE_LOGIN,
            {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    phone,
                    pin,
                }),
            }
        );


        const json = await response.json();


        if (!response.ok) {

            throw new Error(
                json.error || "Employee login failed."
            );

        }


        // Save employee authentication information
        localStorage.setItem(
            "employee",
            JSON.stringify(json)
        );


        setEmployee(json);


        return json;

    };


    // LOGOUT
    const logout = () => {

        localStorage.removeItem("employee");

        setEmployee(null);

    };


    // CHECK EXISTING LOGIN
    useEffect(() => {

        const storedEmployee =
            localStorage.getItem("employee");


        if (storedEmployee) {

            try {

                const employeeData =
                    JSON.parse(storedEmployee);

                setEmployee(employeeData);

            } catch (error) {

                console.error(
                    "Error loading employee authentication:",
                    error
                );

                localStorage.removeItem("employee");

            }

        }

    }, []);


    return (

        <EmployeeAuthContext.Provider
            value={{
                employee,
                login,
                logout,
            }}
        >

            {children}

        </EmployeeAuthContext.Provider>

    );

};